"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ScreenCurved: ['screen-curved', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,21.561a1,1,0,0,0-1-1H13.25a.25.25,0,0,1-.25-.25v-1a.25.25,0,0,0-.25-.25h-1.5a.25.25,0,0,0-.25.25v1a.25.25,0,0,1-.25.25H7.5a1,1,0,0,0,0,2h9A1,1,0,0,0,17.5,21.561Z', 'M23.472,1.793a1.455,1.455,0,0,0-1.265-.318A49.25,49.25,0,0,1,12,2.31,49.25,49.25,0,0,1,1.793,1.475a1.455,1.455,0,0,0-1.265.317A1.506,1.506,0,0,0,0,2.942V16.93a1.5,1.5,0,0,0,.532,1.153,1.46,1.46,0,0,0,1.261.313A49.25,49.25,0,0,1,12,17.561a49.25,49.25,0,0,1,10.207.835,1.451,1.451,0,0,0,1.265-.316A1.506,1.506,0,0,0,24,16.93V2.942A1.5,1.5,0,0,0,23.472,1.793Zm-1.74,14.038a.743.743,0,0,1-.619.163A53.16,53.16,0,0,0,12,15.31,53.055,53.055,0,0,0,2.885,16a.741.741,0,0,1-.617-.164A.752.752,0,0,1,2,15.257V4.615a.751.751,0,0,1,.88-.739A52.987,52.987,0,0,0,12,4.561a52.845,52.845,0,0,0,9.115-.685A.753.753,0,0,1,22,4.615V15.257A.752.752,0,0,1,21.732,15.831Z']],
  Screen: ['screen', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v12.25A.25.25,0,0,0,.25,14h23.5a.25.25,0,0,0,.25-.25V1.5A1.5,1.5,0,0,0,22.5,0Z', 'M23.75,15.5H.25a.25.25,0,0,0-.25.25V17a1.5,1.5,0,0,0,1.5,1.5H9.75a.25.25,0,0,1,.25.25v2.183a.25.25,0,0,1-.22.248,14.386,14.386,0,0,0-3.664.892A1,1,0,0,0,6.492,24H17.5a1,1,0,0,0,.377-1.926,14.373,14.373,0,0,0-3.657-.892.25.25,0,0,1-.22-.248V18.751a.25.25,0,0,1,.25-.25H22.5A1.5,1.5,0,0,0,24,17v-1.25A.25.25,0,0,0,23.75,15.5Z']],
  Screen1: ['screen-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5V14.75A.25.25,0,0,0,.25,15h23.5a.25.25,0,0,0,.25-.25V1.5A1.5,1.5,0,0,0,22.5,0Z', 'M24,16.75a.25.25,0,0,0-.25-.25H.25a.25.25,0,0,0-.25.25V18a1.5,1.5,0,0,0,1.5,1.5h9.249a.247.247,0,0,1,.176.073A.252.252,0,0,1,11,19.75l0,2a.25.25,0,0,1-.25.25H7.5a1,1,0,1,0,0,2h9a1,1,0,0,0,0-2H13.247a.252.252,0,0,1-.177-.074A.247.247,0,0,1,13,21.751l0-2a.25.25,0,0,1,.25-.25H22.5A1.5,1.5,0,0,0,24,18Z']],
  ScreenAlternate: ['screen-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5v15A1.5,1.5,0,0,0,1.5,18H9.75a.25.25,0,0,1,.25.25v2.684a.249.249,0,0,1-.22.248,14.386,14.386,0,0,0-3.66.891A1,1,0,0,0,6.5,24H17.5a1,1,0,0,0,.377-1.926,14.4,14.4,0,0,0-3.661-.892.25.25,0,0,1-.22-.248V18.25a.25.25,0,0,1,.25-.25H22.5A1.5,1.5,0,0,0,24,16.5V1.5A1.5,1.5,0,0,0,22.5,0ZM22,13.5a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5Z']],
  Screen1Alternate: ['screen-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5V18a1.5,1.5,0,0,0,1.5,1.5h9.25a.25.25,0,0,1,.25.25v2a.25.25,0,0,1-.25.25H7.5a1,1,0,0,0,0,2h9a1,1,0,0,0,0-2H13.25a.25.25,0,0,1-.25-.25v-2a.25.25,0,0,1,.25-.25H22.5A1.5,1.5,0,0,0,24,18V1.5A1.5,1.5,0,0,0,22.5,0ZM22,15a.5.5,0,0,1-.5.5H2.5A.5.5,0,0,1,2,15V2.5A.5.5,0,0,1,2.5,2h19a.5.5,0,0,1,.5.5Z']]
};
exports["default"] = _default;